import Popover from "@material-ui/core/Popover";
import ActionSvgComponent from "assets/icons/svg/actionSvg";
// import DeActive from "assets/icons/svg/deActive";
import Tooltip from "@mui/material/Tooltip";
import EyeSvgComponent from "assets/icons/svg/EyeSvg/Eye";
import React from "react";
import DeleteSvgComponent from "../assets/icons/svg/Delete";
import EditSvgComponent from "../assets/icons/svg/Edit/index";

import "./style.scss";

export default function PopOver({
  onEditClick,
  onDeleteClick,
  checkActive,
  onActiveClick,
  onViewClick,
  disabledOnEditClick,
  disabledOnEditClickTooltip,
  disabledOnDeleteClick,
  disabledOnDeleteClickTooltip
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent height={20} width={20} onClick={handleClick} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="action-pop-over">
          {onEditClick ? (
            <Tooltip 
                title={disabledOnEditClickTooltip}
                disableHoverListener={!disabledOnEditClick}
              >
              <div
                className="edit-pop-over"
                onClick={() => {
                  if(disabledOnEditClick) return;
                  onEditClick();
                  handleClose();
                }}
                style={disabledOnEditClick ? {
                  cursor: "not-allowed",
                  opacity: "0.5",
                } : {}}
              >
                <EditSvgComponent className="svg-size" />
                Edit
              </div>
            </Tooltip>
          ) : (
            ""
          )}
            {onViewClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onViewClick();
                handleClose();
              }}
            >
              <EyeSvgComponent className="svg-size" />
              View
            </div>
          ) : (
            ""
          )}
          {onActiveClick ? (
            <div
              className="center-pop-over"
              onClick={() => {
                onActiveClick();
                handleClose();
              }}
            >
              {/* <DeActive className="svg-size" /> */}
              {!checkActive ? "Activate" : " Deactivate"}
            </div>
          ) : (
            ""
          )}
          {onDeleteClick ? (
            <Tooltip 
            title={disabledOnDeleteClickTooltip}
            disableHoverListener={!disabledOnDeleteClick}
            >
              <div
                className="delete-pop-over"
                onClick={() => {
                  if(disabledOnDeleteClick) return;
                  onDeleteClick();
                  handleClose();
                }}
                style={disabledOnDeleteClick ? {
                  cursor: "not-allowed",
                  opacity: "0.5",
                } : {}}
              >
                <DeleteSvgComponent className="svg-size" />
                Delete
              </div>
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      </Popover>
    </div>
  );
}
